import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import ExecLogModal from '@/components/container/modal/automationReview/ExecLogModal'

interface ExecLogModalState {
  siteId: number
  actionIds: number[]
  title: string
}

const defaultValue: ExecLogModalState = { siteId: 0, actionIds: [], title: '' }

export const ExecLogModalContext = createModalContext<ExecLogModalState>(defaultValue)

const ExecLogModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<ExecLogModalState>(defaultValue)
  return (
    <ExecLogModalContext.Provider value={state}>
      {children}
      <ExecLogModal />
    </ExecLogModalContext.Provider>
  )
}

export default ExecLogModalProvider
